import * as Mutations from './mutations';
import * as ROLES from '@/constants/user-types';
import {clearAllSelected} from '@/store/modules/page/reset';
import {SchoolClassService} from '@/common/services/pages/classes.service';
import {PaginationParams} from '@/common/utils/pagination-params';

export const ClassPageModule = {
    state: {
        className: null,
        classList: null
    },

    mutations: {
        [Mutations.SET_CLASS_LIST](state, classList) {
            state.classList = classList;
        },

        [Mutations.ADD_TO_CLASS_LIST](state, list) {
            state.classList.push(...list);
        },

        [Mutations.REMOVE_CLASS](state, classId) {
            state.classList = state.classList.filter(schoolClass => schoolClass.id !== classId);
        },

        [Mutations.RESET_CLASS_LIST](state) {
            state.classList = [];
        },

        [Mutations.REMOVE_CLASS_LIST](state) {
            state.classList = null;
        },

        [Mutations.FETCHED_CLASS_NAME](state, className) {
            state.className = className;
        },

        [Mutations.CLEAR_CLASS_NAME](state) {
            state.className = null;
        }
    },

    actions: {
        async getClassList(context, { schoolId } = { schoolId: context.getters.schoolId }) {
            const { userRole } = context.getters;
            const request = userRole === ROLES.SCHOOL_INSTRUCTOR
                ? params => SchoolClassService.getClassesByInstructor(context.getters.schoolId, context.getters.userId, params)
                : params => SchoolClassService.getClasses(schoolId, params);
            const { data: { content, pageable, totalPages, totalElements, numberOfElements } } =
                await request(
                    PaginationParams.createParams({
                        size: context.getters.pageSize,
                        page: context.getters.pageNumber,
                        sort: context.getters.sortBy,
                        direction: context.getters.direction,
                        query: context.getters.searchQuery,
                        filters: {
                            ...context.getters.filters
                        }
                    }));
            context.commit(Mutations.SET_CLASS_LIST, content);
            context.dispatch('configPagination', {
                ...pageable,
                numberOfElements,
                totalElements,
                totalPages,
                callback: () => {
                    return context.dispatch('getClassList', { schoolId });
                }
            });
            if (userRole && userRole !== ROLES.SCHOOL_INSTRUCTOR) {
                context.dispatch('getClassesGeneralInfo');
            }
        },

        async deleteClass(context, classId) {
            await context.dispatch('deleteClasses', [ classId ]);
        },

        async deleteMultipleClasses(context) {
            await context.dispatch('deleteClasses', context.getters.selected);
        },

        async deleteClasses(context, classIds) {
            const { schoolId } = context.getters;
            await SchoolClassService.deleteMultipleClasses(schoolId, classIds);
            context.dispatch('resetSelectedItems');
            context.dispatch('resetFilter');
            if (classIds.length === context.getters.classList.length) {
                context.dispatch('openPreviousPage');
            }
            clearAllSelected();
            await context.dispatch('getClassList', { schoolId });
        },

        async bulkUpdateClasses(context, form) {
            await SchoolClassService.bulkUpdateClasses(context.getters.schoolId, context.getters.selected, form);
            await context.dispatch('getClassList');
            context.dispatch('resetSelectedItems');
        },

        async fetchClassNameById(context, classId) {
            const { data } = await SchoolClassService.getClassName(context.getters.schoolId, classId);
            context.commit(Mutations.FETCHED_CLASS_NAME, data);
        }
    },

    getters: {
        classList: state => state.classList,

        className: state => state.className
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/class-page/class-page.module.js